export enum AppUserType {
  PASSPORT = 'passport',
  VMS = 'vms',
  LOCUMS = 'locums',
}
